import AddressModel from '$gbusiness/models/address';
import { toLocal } from '$gbusiness/helpers/date';
import { parseAddress } from '$gbusiness/helpers/util';
import TaxModel, { deriveRawToTax } from './tax';
import VendorModel, { deriveRawToVendor } from './vendor';
import ShippingModel, { deriveRawToShipping } from './shipping';
import DiscountModel, { deriveRawToDiscount } from './discount';
import CommRuleModel, { deriveRawToCommRule } from './commRule';
import RegionModel, { deriveRawToRegion } from './region';
import BankModel, { deriveRawToBank } from './bank';
import TermModel, { deriveRawToTerm } from './term';

export default interface FactoryModel {
  factoryId: number;
  name: string;
  code: string;
  type: string;
  formatted?: string;
  address?: AddressModel | undefined;
  placeId?: string;
  email: string;
  phone: string;
  createdAt?: string;
  logo?: string;
  vendors: Array<VendorModel>;
  taxes: Array<TaxModel>;
  discounts: Array<DiscountModel>;
  commRules: Array<CommRuleModel>;
  shippings: Array<ShippingModel>;
  regions: Array<RegionModel>;
  banks: Array<BankModel>;
  terms: Array<TermModel>;
  settings?: any;
  updatedAt?: string;
}

export const deriveRawToFactory = (raw) => {
  return {
    factoryId: raw.id,
    name: raw.name,
    code: raw.code,
    type: raw.type,
    formatted: raw.address,
    ...(raw.address && { address: parseAddress(raw.address) }),
    placeId: raw.placeId,
    email: raw.email,
    phone: raw.phone,
    ...(raw.image && { logo: raw.image?.fileUrl }),
    createdAt: toLocal(raw.createdAt),
    updatedAt: toLocal(raw.updatedAt),
    vendors: raw.vendors.map(deriveRawToVendor),
    commRules: (raw.commRules || []).map(deriveRawToCommRule),
    discounts: (raw.discounts || []).map(deriveRawToDiscount),
    regions: (raw.regions || []).map(deriveRawToRegion),
    taxes: (raw.taxes || []).map(deriveRawToTax),
    shippings: (raw.shippingOptions || []).map(deriveRawToShipping),
    banks: (raw.banks || []).map(deriveRawToBank),
    terms: (raw.terms || []).map(deriveRawToTerm),
    settings: raw.settings || factoryFeatures,
    // shippings: raw.shippings ? raw.shippings.map(v => deriveRawToShipping(v)) : mockShippings, // remove mocks later
  };
};

export const factoryFeatures = {
  invoice: false,
  subcategory: false,
  file: false,
  productSize: 200,
  card: false,
  ebrochure: false,
  notification: false,
  textConfirmation: false,
  hidePrice: false,
  pickupOnly: false,
  kongdog: false,
  wholesaleEmail: '',
  showVendor: false,
  retailEmail: '',
  commission: false,
  discounts: false,
  refundVoucher: false,
  regions: false,
  terms: false,
  dailyReport: false,
  disableCustomer: false,
};

export const initialFactory: FactoryModel = {
  factoryId: 0,
  name: '',
  code: '',
  type: '',
  formatted: '',
  placeId: '',
  email: '',
  phone: '',
  vendors: [],
  taxes: [],
  shippings: [],
  commRules: [],
  discounts: [],
  regions: [],
  banks: [],
  terms: [],
  settings: {
    ...factoryFeatures,
  },
};
